import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocumentCaseData } from '../../../../../core/services/document.models';

@Component({
    selector: 'app-doc-cover-letter',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './doc-cover-letter.component.html',
    styleUrl: './doc-cover-letter.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class DocCoverLetterComponent {
    @Input() caseData: DocumentCaseData | null = null;
    @Output() downloadPdf = new EventEmitter<void>();

    @ViewChild('docCard', { read: ElementRef }) docCard!: ElementRef<HTMLElement>;

    get patientName():    string { return this.caseData?.patient_first_name ? `${this.caseData.patient_first_name} ${this.caseData.patient_last_name}` : '[Patient Name]'; }
    get providerName():   string { return this.caseData?.provider_name      ?? '[Provider Name]'; }
    get accountNumber():  string { return this.caseData?.account_number     ?? '[Account #]'; }
    get dateOfService():  string { return this.caseData?.date_of_service    ?? '[Date of Service]'; }
    get offerAmount():    string { const v = this.caseData?.offer_amount;        return v != null ? `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$[Offer Amount]'; }
    get billedCharges():  string { const v = this.caseData?.full_billed_charges; return v != null ? `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$[FBC]'; }
    get trustAmount():    string { const v = this.caseData?.trust_amount;        return v != null ? `$${v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : '$[Trust Amount]'; }
    get todayDate():      string { return new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }); }
}
